import {
  cilApplicationsSettings,
  cilDrop,
  cilPuzzle,
  cilMoon,
  cilSpeedometer,
  cilSun,
  cilBell,
  cilUserFollow,
  cilUserUnfollow,
  cilChartPie,
  cilBasket,
  cilEnvelopeClosed,
  cilWarning,
  cilEnvelopeOpen,
  cilTask,
  cilCommentSquare,
  cilUser,
  cilSettings,
  cilDollar,
  cilFile,
  cilShieldAlt,
  cilLockLocked,
  cilList,
  cilSpeech,
  cilCalendar,
  cilLocationPin,
  cibSkype,
  cilHome,
  cilNotes,
  cilMagnifyingGlass,
  cilPencil,
  cilTrash,
  cilCloudDownload,
  cilPlus,
  cilCircle,
  cilScreenDesktop,
  cilBarChart,
  cilPeople,
  cilPowerStandby,
  cilReload,
  cilLoopCircular,
  cilArrowCircleTop,
  cilArrowTop,
  cilArrowBottom
} from '@coreui/icons'
import { logo } from './logo'

export const iconsSet = Object.assign({}, {
  cilApplicationsSettings,
  cilDrop,
  cilPuzzle,
  cilMoon,
  cilSpeedometer,
  cilSun,
  cilBell,
  cilUserFollow,
  cilUserUnfollow,
  cilChartPie,
  cilBasket,
  cilEnvelopeClosed,
  cilWarning,
  cilEnvelopeOpen,
  cilTask,
  cilCommentSquare,
  cilUser,
  cilSettings,
  cilDollar,
  cilFile,
  cilShieldAlt,
  cilLockLocked,
  cilList,
  cilSpeech,
  cilCalendar,
  cilLocationPin,
  cibSkype,
  cilHome,
  cilNotes,
  cilMagnifyingGlass,
  cilPencil,
  cilTrash,
  cilCloudDownload,
  cilPlus,
  cilCircle,
  cilScreenDesktop,
  cilBarChart,
  cilPeople,
  cilPowerStandby,
  cilReload,
  cilLoopCircular,
  logo,
  cilArrowCircleTop,
  cilArrowTop,
  cilArrowBottom
})
